import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=e62caac6&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=e62caac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e62caac6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e62caac6')) {
      api.createRecord('e62caac6', component.options)
    } else {
      api.reload('e62caac6', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=e62caac6&scoped=true&", function () {
      api.rerender('e62caac6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2F0UcIGRT4mck/JS/comp/CookieBox.vue"
export default component.exports